import logoRs from '../../assets/cifrao.png';
import './form.css';
import { useState } from 'react';
import { v4 as uuid } from 'uuid';

export const Form = ({listTransactions, setListTransactions}) =>{
        const [description, setDescription] = useState('');
        const [value, setValue] = useState('');
        const [option, setOption] = useState('');

        const onSubmit = (e) =>{
            e.preventDefault()
            const data = {
                id: uuid(),
                description: description,
                value: option === 'Saída' ? - parseInt(value) : parseInt(value), 
                option: option,
            }
            setListTransactions([...listTransactions, data]);
        }

    return(
        <form className='formulario'>
            <label htmlFor='descricao'>Descrição</label>
            <input type='text' id='descricao' placeholder='Digite aqui sua descrição' 
            value={description} onChange={(e) => setDescription(e.target.value)}/>
            <div className='div-valor'>
                <div className='valor'>
                    <label htmlFor='valor'>Valor</label>
                    <div className='div-valor-cifrao'>
                        <input type='text' placeholder='1'
                        value={value} onChange={(e) => setValue(e.target.value)}/>
                        <img src={logoRs} alt='logo-RS' />
                    </div>
                </div>
                <div className='tipo-de-valor'>
                    <label htmlFor='tipoDeValor'>Tipo de Valor</label>
                    <select name='tipoDeValor'
                    value={option} onChange={(e) => setOption(e.target.value)}>
                        <option value='Entrada'>Entrada</option>
                        <option value='Saída'>Saída</option>
                    </select>
                </div>
            </div>
            <button type='submit' onClick={onSubmit}>Inserir valor</button>
        </form>
    )
}